import { Component, OnInit } from '@angular/core'
import { WebViewService } from '@se-po/shared-data-access-services'

@Component({
  selector: 'app-account-page',
  templateUrl: './account-page.component.html',
  styleUrls: ['./account-page.component.scss']
})
export class AccountPageComponent implements OnInit {
  public displayHeader = false

  public constructor(
    private webViewService: WebViewService
  ) {
    // noop
  }

  public ngOnInit(): void {
    // noop
    this.displayHeader = !this.webViewService.current
  }

}
